import React, { useCallback, useEffect, useRef, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import styles from '../../css/style.module.css'
import './Chats.css'
import { IoIosSend } from "react-icons/io";

import img4 from '../../assest/loading1.gif'
import img5 from '../../assest/img7.png'

import endPoints from '../../Repository/apiConfig';
import { getApi } from '../../Repository/Api';
import {
  doc,
  onSnapshot,
  arrayUnion,
  setDoc
} from 'firebase/firestore';

import { db } from '../../components/Firebase/Firebase-config';
import { formatDistanceToNow } from 'date-fns';
import { Link, useLocation } from 'react-router-dom';
import { formatDatemessage, getFormattedTime, isToday2, isYesterday2 } from '../../utils/utils';


const Chats = () => {
  const location = useLocation();
  const userId = location.state?.userId;
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [isAtBottom, setIsAtBottom] = useState(true);


  const [userdata, setUserData] = useState([])
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState({
    name: 'user',
    img: img5,
    id: null,
  });
  const [search, setSearch] = useState('')
  const [limit, setLimit] = useState(0);
  const adminData = JSON.parse(localStorage.getItem("adminData")) || {};
  const [activeUser, setActiveUser] = useState(null);

  const messageContainerRef = useRef(null);
  const unsubscribeRefs = useRef([]);

  const fetchData = useCallback(async () => {
    unsubscribeRefs.current.forEach(unsub => unsub());
    unsubscribeRefs.current = [];

    await getApi(endPoints.getalluser(1, limit, search), {
      setResponse: async (response) => {
        const users = response?.data?.docs || [];
        setLimit(response?.data?.totalDocs);

        // Set initial user data
        setUserData(users);

        // Set up Firestore listeners for each user
        users.forEach(user => {
          const chatId = `${user._id}_${adminData?.data?._id}`;
          const chatRef = doc(db, "chats", chatId);

          const unsubscribe = onSnapshot(chatRef, (doc) => {
            if (!doc.exists()) return;

            const messages = doc.data().messages || [];
            const lastMessage = messages[messages.length - 1];

            setUserData(prev => {
              const updatedUsers = prev.map(u => {
                if (u._id === user._id) {
                  return {
                    ...u,
                    lastMessage: lastMessage?.message || 'No messages yet',
                    lastMessageTime: lastMessage?.timestamp || null,
                    tag: lastMessage?.tag || null
                  };
                }
                return u;
              });

              // Sort users by last message time
              return [...updatedUsers].sort((a, b) => {
                const timeA = new Date(a.lastMessageTime || 0);
                const timeB = new Date(b.lastMessageTime || 0);
                return timeB - timeA;
              });
            });
          });

          unsubscribeRefs.current.push(unsubscribe);
        });
      },
      setLoading,
      errorMsg: 'Failed to fetch users!',
    });
  }, [limit, search, adminData?.data?._id]);

  useEffect(() => {
    return () => unsubscribeRefs.current.forEach(unsub => unsub());
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  useEffect(() => {
    if (location.state?.selectedUser) {
      setSelectedUser({
        name: location.state.selectedUser.name,
        img: location.state.selectedUser.img,
        id: location.state.selectedUser.id
      });
    }
  }, [location.state]);



  useEffect(() => {
    if (selectedUser && adminData?.data?._id) {
      const chatId = `${selectedUser.id}_${adminData?.data?._id}`;
      const chatRef = doc(db, "chats", chatId);

      const unsubscribe = onSnapshot(chatRef, (doc) => {
        if (doc.exists()) {
          setMessages(doc.data().messages || []);
        } else {
          setMessages([]); // If no document exists, show an empty chat
        }
      });

      return () => unsubscribe(); // Cleanup listener on component unmount
    }
  }, [selectedUser, adminData?.data?._id]);





  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSendMessage = async () => {
    if (newMessage.trim() === "") return;
    setNewMessage("");

    const chatId = `${selectedUser.id}_${adminData?.data?._id}`;
    const chatRef = doc(db, "chats", chatId);

    try {
      await setDoc(
        chatRef,
        {
          adminId: adminData?.data?._id,
          adminName: adminData?.data?.fullName,
          adminProfilePic: adminData?.data?.image,
          messages: arrayUnion({
            senderId: adminData?.data?._id,
            senderName: adminData?.data?.fullName,
            senderProfilePic: adminData?.data?.image,
            message: newMessage,
            timestamp: new Date().toISOString(),
          }),
        },
        { merge: true }
      );
      setNewMessage("");
    } catch (error) {
      console.error("Error sending message:", error.message);
    }
  };

  //  const handleSendMessagebyUser = async () => {
  //     if (newMessage.trim() === "") return;

  //     const chatId = `${selectedUser.id}_${adminData?.data?._id}`;
  //     const chatRef = doc(db, "chats", chatId);

  //     try {
  //       await setDoc(
  //         chatRef,
  //         {
  //           userId: selectedUser?.id,
  //           userName: selectedUser?.name,
  //           userProfilePic: selectedUser?.img,
  //           messages: arrayUnion({
  //             senderId: selectedUser?.id,
  //             senderName: selectedUser?.name,
  //             senderProfilePic: selectedUser?.img,
  //             message: newMessage,
  //             timestamp: new Date().toISOString(),
  //           }),
  //         },
  //         { merge: true } 
  //       );

  //       setNewMessage(""); 
  //     } catch (error) {
  //       console.error("Error sending message:", error.message);
  //     }
  //   };


  const getTimeAgo = (timestamp) => {
    return formatDistanceToNow(new Date(timestamp), { addSuffix: true });
  };

  const routeMapping = {
    User: "/chats/user",
    Staff: "/chats/staff",
  };


  const scrollToBottom = useCallback(() => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTo({
        top: messageContainerRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, []);

  const handleScroll = () => {
    const container = messageContainerRef.current;
    if (container) {
      const isNearBottom =
        container.scrollHeight - container.scrollTop <= container.clientHeight + 50;
      setIsAtBottom(isNearBottom); // Set the state to true only if the user is near the bottom
    }
  };

  const selecteduser = (user) => {
    setSelectedUser({
      name: `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'User',
      img: user?.image || img5,
      id: user?._id || null,
    });
    setActiveUser(user._id);
    setMessages([]);
    scrollToBottom();
  };


  useEffect(() => {
    if (userId) {
      selecteduser(userId); // Auto-scroll only if the user is at the bottom
    }
  }, [userId]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };


  useEffect(() => {
    scrollToBottom();
  }, [messages, scrollToBottom]);



  const groupedMessages = messages.reduce((acc, msg) => {
    const messageDate = new Date(msg.timestamp);
    let groupKey;

    if (isToday2(messageDate)) {
      groupKey = "Today";
    } else if (isYesterday2(messageDate)) {
      groupKey = "Yesterday";
    } else {
      groupKey = formatDatemessage(messageDate);
    }

    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }

    acc[groupKey].push(msg);
    return acc;
  }, {});




  return (
    <>
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>chats</h6>
          </div>
        </div>
        <div className={styles.jobselectcontainer}>
          <div className={styles.jobStatusContainer}>
            {['User', 'Staff'].map((item, index) => (
              <Link key={index} to={routeMapping[item]} className={styles.link}>
                <p
                  className={
                    item === 'User'
                      ? styles.jobOptionTrueactive
                      : styles.jobOptionnotactive
                  }
                >
                  {item}
                </p>
              </Link>
            ))}
          </div>
        </div>
        <div className='chatcontainer'>
          <div className='chat-left'>
            <div className='chat-left-head'>
              <div className='chat-left-head1'>
                <h6>Messages of User</h6>
              </div>
            </div>
            <div className='chat-left-main'>
              <div className='chat-left-searchbar'>
                <input type="search"
                  placeholder="Search"
                  value={search}
                  onChange={handleSearchChange} />
              </div>
              <div className="chat-left-userlist">
                {loading ? (
                  <div className="loadingnormal11">
                    <img src={img4} alt="Loading" width={100} height={100} />
                  </div>
                ) : userdata?.data?.docs?.length === 0 ? (
                  <div className="loadingnormal11">
                    <p>No data available.</p>
                  </div>
                ) : (
                  userdata?.map((chat, index) => {
                    return (
                      <div
                        key={index}
                        className={`chat-left-user ${activeUser === chat._id ? "active" : ""}`}
                        onClick={() => selecteduser(chat)}
                      >
                        <div className="chat-left-user1">
                          <div className="chat-left-user-img">
                            <img src={chat.image ? chat.image : img5} alt={`${chat.firstName}'s profile`} />
                          </div>
                          <div className="chat-left-user-name">
                            <h6>{chat.firstName ? chat.firstName : "User"} {chat.lastName}</h6>
                            <p>{chat.lastMessage?.length > 15 ? `${chat?.lastMessage?.substring(0, 15)}....` : chat?.lastMessage || "lastMessage"}</p>
                            {chat.tag ?
                              <div className='chat-left-user-tag'>
                                <div className={`chat-left-user-tag-${chat.tag}`}>
                                  <p>{chat.tag}</p>
                                </div>
                              </div>
                              : <>
                              </>
                            }
                          </div>
                        </div>
                        <div className="chat-left-user-time">
                          <span>{chat?.lastMessageTime ? getTimeAgo(new Date(chat?.lastMessageTime)) : ""}</span>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
          <div className='chat-right'>
            <div className='chat-right-head'>
              <div className='chat-right-user-img'>
                <img src={selectedUser.img} alt="" />
              </div>
              <div className='chat-right-user-name'>
                <h1>{selectedUser.name}</h1>
                {/* <span><MdCircle />Online</span> */}
              </div>
            </div>
            <div className="chat-right-main" ref={messageContainerRef} onScroll={handleScroll}>
              {Object.entries(groupedMessages).map(([date, msgs]) => (
                <div key={date}>
                  {/* Date Header */}
                  <div className="chat-date-header">
                    <span>{date}</span>
                  </div>

                  {/* Messages for the Date */}
                  {msgs.map((msg, index) => (
                    <div
                      key={index}
                      className={`chat-right-message-${msg.senderId === adminData?.data?._id ? "right" : "left"}`}
                    >
                      {msg.senderId === adminData?.data?._id ? (
                        <>
                          <div className="chat-right-right-msg-div-div">
                            <p>{msg.message}</p>
                            <span>{getFormattedTime(msg.timestamp)}</span>
                          </div>
                          <div className="chat-right-right-msg-img">
                            <img src={msg.senderProfilePic} alt={msg.senderName} />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="chat-right-left-msg-img">
                            <img src={msg.senderProfilePic} alt={msg.senderName} />
                          </div>
                          <div className="chat-right-left-msg-div-div">
                            <p>{msg.message}</p>
                            <span>{getFormattedTime(msg.timestamp)}</span>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <div className="chat-send-message">
              {/* <IoIosAttach /> */}
              <div className="chat-send-message-div">
                <input
                  type="text"
                  placeholder="Type a message"
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <IoIosSend onClick={handleSendMessage} />
                {/* <IoIosSend onClick={handleSendMessagebyUser} /> */}
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  )
}

export default HOC(Chats)
